import {Form, Input, InputNumber} from 'antd'
import { Dispatch, SetStateAction, useState } from 'react'
import { PaymentSummaryRequestDTO } from '../../model/PaymentSummaryRequestDTO'
import {PaymentSummary} from "../../model/PaymentSummary";


export const PaymentPopover : React.FC<{passedCustomerid : number | undefined, paymentsummary : PaymentSummary | undefined
  setShowPayment : Dispatch<SetStateAction<boolean>>,
  handleSaveToDatabase : (paymentSummaryRequestDTO: PaymentSummaryRequestDTO, passedCustomerid : number) => Promise<() => void>,
}> = (props) => {

    const {passedCustomerid, paymentsummary, setShowPayment, handleSaveToDatabase} = props
    const [value, setValue] = useState<number | undefined>(undefined)
    const [description, setDescription] = useState<string>("")
    const [error, setError] = useState<boolean>(true)
    const [errorValueMessage, setErrorValueMessage] = useState<string>("")
    const [errorDescriptionMessage, setErrorDescriptionMessage] = useState<string>("")
    
    const handleValue = (value : any) => {
        if (value === null || value === undefined) {
            setValue(undefined)
            setError(true)
            setErrorValueMessage("")
        } else if (validateValue(value)) {
            setValue(value)
        }
    }

    const handleDescription = (value : any) => {
      if (validateValue(value)) {
        setDescription(value)
      }
    }

    const handleClick = ()=> {
        let paymentSummaryRequestDTO
            = new PaymentSummaryRequestDTO(paymentsummary!.paymentsummaryid!,
              value!,null, description)
        handleSaveToDatabase(paymentSummaryRequestDTO, passedCustomerid!)
      setShowPayment(false)
    }

    const validateValue = (valueToValidate : any) : boolean => {
      let result = false
      switch(typeof valueToValidate) {
          case 'number':
              if (valueToValidate === 0) {
                  setValue(0)
                  setErrorValueMessage("Błąd! Wartość nie może być pusta lub być zerem.")
                  result = false
              } else if (valueToValidate >= 5000 || valueToValidate <= -5000) {
                  setValue(valueToValidate > 0 ? 5000 : -5000)
                  setErrorValueMessage("Uwaga! Wartość nie może być większa niż 5000 zł i mniejsza niż -5000 zł.")
                  result = false
              } else {
                  setErrorValueMessage("")
                  result = true
              }
              break
          case 'string':
              if (valueToValidate.length >= 50) {
                setErrorDescriptionMessage("Uwaga! Opis nie może przekraczać 50 znaków.")
                result = false
              } else {
                setErrorDescriptionMessage("")
              result = true
              }
              break
          default:
              setErrorDescriptionMessage("")
              setErrorValueMessage("")
      }
      setError(errorValueMessage.length > 0 || errorDescriptionMessage.length > 0 || value === undefined)
      return result
    }

    return (
        <Form style={{ width: '100%' }}>
          <Form.Item
            validateStatus={errorValueMessage.startsWith("Błąd") ? "error" : errorValueMessage.startsWith("Uwaga") ? "warning" : "validating"}
            help={errorValueMessage}>
            <InputNumber placeholder="Podaj kwotę"
                addonBefore="Kwota"
                addonAfter="PLN"
                defaultValue={undefined}
                value={value}
                precision={2}
                decimalSeparator='.'
                max={5000}
                min={-5000}
                onChange={e => handleValue(e)}/>
          </Form.Item>
          <Form.Item
            validateStatus={errorDescriptionMessage.startsWith("Błąd") ? "error" : errorDescriptionMessage.startsWith("Uwaga") ? "warning" : "validating"}
            help={errorDescriptionMessage}>
            <Input placeholder="Podaj dodatkowy opis"
              addonBefore="Opis"
              defaultValue={undefined}
              value={description}
              maxLength={50}
              onChange={e => handleDescription(e.target.value)}/>
          </Form.Item>
          <Form.Item style={{ textAlign: 'center', marginBottom : 0}} >
            <button disabled={error} type="button" className='button-65-mobile' onClick={() => handleClick()}>
                Dodaj płatność
            </button>
          </Form.Item>
        </Form>
    )
}